'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactRedux = require('react-redux');

var _reactRouterRedux = require('react-router-redux');

var _templateData = require('redux/modules/templateData');

var templateActions = _interopRequireWildcard(_templateData);

var _semanticUiReact = require('semantic-ui-react');

require('./ChartEditor.css');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = require('./ChartEditor.scss');

var ChartEditor = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    primary_color: state.templateData.primary_color,
    info_block: state.templateData.info_block
  };
}, {
  updatePrimaryColor: templateActions.updatePrimaryColor,
  updateSecondaryColor: templateActions.updateSecondaryColor,
  updateChartData: templateActions.updateField
}), _dec(_class = function (_Component) {
  (0, _inherits3.default)(ChartEditor, _Component);

  function ChartEditor(props) {
    (0, _classCallCheck3.default)(this, ChartEditor);

    // const {  } = this.props;
    var _this = (0, _possibleConstructorReturn3.default)(this, (ChartEditor.__proto__ || (0, _getPrototypeOf2.default)(ChartEditor)).call(this, props));

    _this.handleChange = function (e, _ref) {
      var name = _ref.name,
          value = _ref.value;


      if (name === 'newValue') {
        if (!isNaN(value)) {
          _this.setState((0, _defineProperty3.default)({}, name, value));
        }
      } else {
        _this.setState((0, _defineProperty3.default)({}, name, value));
      }
    };

    _this.addDataPoint = function () {
      var _this$state = _this.state,
          newSkill = _this$state.newSkill,
          newValue = _this$state.newValue,
          chartDataArray = _this$state.chartDataArray;
      var _this$props = _this.props,
          chartX = _this$props.chartX,
          chartY = _this$props.chartY,
          data_parent = _this$props.data_parent,
          data_id = _this$props.data_id,
          data_type = _this$props.data_type;

      var newChartDataArray;

      //checking if new value is blank or not
      if (newValue !== '') {
        //checking if chartDataArray is empty
        if (chartDataArray) {
          if (!isNaN(newValue)) {
            newChartDataArray = [].concat((0, _toConsumableArray3.default)(chartDataArray), [{ "skill": newSkill, "x": parseInt(newValue) }]);
          }
        } else {
          if (!isNaN(newValue)) {
            newChartDataArray = [{ "skill": newSkill, "x": parseInt(newValue) }];
          }
        }
        var chartDataArrayString = (0, _stringify2.default)(newChartDataArray);
        _this.props.updateChartData(chartDataArrayString, data_id, data_type, data_parent);
        _this.setState({ chartDataArray: newChartDataArray });
      }
    };

    _this.closeChartEditor = function (e) {

      if (!(0, _reactDom.findDOMNode)(_this).contains(e.target) && e.target.textContent !== 'Delete') {
        _this.props.handleChartVisibility();
      }
    };

    _this.deleteDataPoint = function (e, index) {
      var _this$state2 = _this.state,
          newSkill = _this$state2.newSkill,
          newValue = _this$state2.newValue,
          chartDataArray = _this$state2.chartDataArray;
      var _this$props2 = _this.props,
          chartX = _this$props2.chartX,
          chartY = _this$props2.chartY,
          data_parent = _this$props2.data_parent,
          data_id = _this$props2.data_id,
          data_type = _this$props2.data_type;

      chartDataArray.splice(index, 1);
      var chartDataArrayString = (0, _stringify2.default)(chartDataArray);
      _this.props.updateChartData(chartDataArrayString, data_id, data_type, data_parent);
      _this.setState({ chartDataArray: chartDataArray });
    };

    _this.handleInputChange = function (e, data, index, type) {
      var chartDataArray = _this.state.chartDataArray;

      var elementID = _this.props.data_id;
      var elementParent = _this.props.data_parent;
      var elementType = _this.props.data_type;

      if (type === 'x') {
        if (data.value === '') {
          chartDataArray[index][type] = 0;
        } else if (!isNaN(data.value)) {
          chartDataArray[index][type] = parseInt(data.value);
        }
      } else {
        chartDataArray[index][type] = data.value;
      }

      _this.setState(chartDataArray);
      var chartDataArrayString = (0, _stringify2.default)(chartDataArray);
      _this.props.updateChartData(chartDataArrayString, elementID, elementType, elementParent);
    };

    _this.state = {
      newSkill: '',
      newValue: '',
      chartDataArray: []
    };
    return _this;
  }

  (0, _createClass3.default)(ChartEditor, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      document.addEventListener('click', this.closeChartEditor, false);

      var data;
      var info_block = this.props.info_block[this.props.data_parent];
      data = info_block[this.props.data_id][this.props.data_type] === '' ? '' : JSON.parse(info_block[this.props.data_id][this.props.data_type]);
      this.setState({ chartDataArray: data });
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      document.removeEventListener('click', this.closeChartEditor, false);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          chartX = _props.chartX,
          chartY = _props.chartY,
          data_parent = _props.data_parent,
          data_id = _props.data_id,
          data_type = _props.data_type;
      var _state = this.state,
          newSkill = _state.newSkill,
          newValue = _state.newValue,
          chartDataArray = _state.chartDataArray;


      return _react2.default.createElement(
        _semanticUiReact.Form,
        { size: 'tiny', style: { borderRadius: '5px', border: '1px solid grey', padding: '20px', minWidth: '500px', position: 'absolute', left: chartX + 'px', top: chartY + 'px', backgroundColor: 'white', zIndex: '99' } },
        chartDataArray && chartDataArray.map(function (skillObject, index) {
          return _react2.default.createElement(
            _semanticUiReact.Form.Group,
            { key: index + 1 },
            _react2.default.createElement(_semanticUiReact.Form.Input, {
              label: 'Skill-' + (index + 1),
              width: 10,
              placeholder: 'skill',
              value: skillObject.skill,
              onChange: function onChange(e, data) {
                return _this2.handleInputChange(e, data, index, 'skill');
              }
            }),
            _react2.default.createElement(_semanticUiReact.Form.Input, {
              label: 'Value-' + (index + 1),
              width: 10,
              placeholder: 'value',
              value: skillObject.x,
              onChange: function onChange(e, data) {
                return _this2.handleInputChange(e, data, index, 'x');
              }
            }),
            _react2.default.createElement(_semanticUiReact.Form.Button, { style: { marginTop: '22px', width: '84px' }, onClick: function onClick(e) {
                return _this2.deleteDataPoint(e, index);
              }, content: 'Delete' })
          );
        }),
        _react2.default.createElement(
          _semanticUiReact.Form.Group,
          null,
          _react2.default.createElement(_semanticUiReact.Form.Input, { label: 'Add New Skill', width: 10, placeholder: 'Enter Skill', name: 'newSkill', value: newSkill, onChange: this.handleChange }),
          _react2.default.createElement(_semanticUiReact.Form.Input, { label: 'Add New Value', width: 10, placeholder: 'Enter Value', name: 'newValue', value: newValue, onChange: this.handleChange }),
          _react2.default.createElement(_semanticUiReact.Form.Button, { secondary: true, style: { marginTop: '22px', width: '84px' }, onClick: this.addDataPoint, content: 'Add' })
        )
      );
    }
  }]);
  return ChartEditor;
}(_react.Component)) || _class);
exports.default = ChartEditor;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/ChartEditor/ChartEditor.js
// module id = 1732
// module chunks = 0